// extracted by mini-css-extract-plugin
module.exports = {"accordion":"style-module--accordion--slG0h","question":"style-module--question--20ko5","opened":"style-module--opened--2PD1T","answer":"style-module--answer--3FroU"};